<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Certificate Label Verification </h5>
      <br />

      <br>
      <br>
      <div class="row">

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Letter Number</label>
          <input [(ngModel)]="Filter_Letter_Id" 
            name="Filter_Letter_Id" type="number" class="form-control"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Customer Name</label>
          <input [(ngModel)]="Filter_Customer"
            name="Filter_Customer" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <button type="button" (click)="ReadData_Certificate()" class="btn btn-info" style="margin-right: 5px;"><i
              class="fa  fa-search"></i> Search </button>

        <button *ngIf="!Procssing" (click)="openModal(templateOperationList,1,0)" type="button" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa fa-plus-circle"></i> Approve </button>

          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>

      </div>

      <br>
      <br>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>
                <input type="checkbox" [checked]="Check_All" (click)="onChange_CheckAll()" />
              </th>
              <th>#</th>
              <th>Receipt ID</th>
              <th>Customer Name</th>
              <th>Equipment Code</th>
              <th>Equipment Serial Number</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Certificate
            | paginate
                    : {
                        id: 'DataList_CertificateTable',
                        itemsPerPage: 20,
                        currentPage: page,
                        totalItems: (DataList_Certificate).length
                      }
            " [ngClass]="{'alarm': item.alarm===1}">
              <td>
                <input type="checkbox"  [checked]="item.selected"
                  (click)="onChange_CheckItem(item)" />
              </td>
              <td>{{DataList_Certificate.indexOf(item)+1}}</td>
              <td>{{item['code2']}}</td>
              <td>{{item['customerName']}}</td>
              <td>{{item['code']}}</td>
              <td>{{item['serial']}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_CertificateTable" nextLabel="Next" previousLabel="Previous"
      (pageChange)="page = $event"></pagination-controls>
  </div>
</div>


<ng-template #templateOperationList>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Approve </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_operation.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button (click)="ConfirmList()" type="button" class="btn btn-success" style="margin-right: 5px;"><i
        class="fa  fa-plus-circle"></i> Approve </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_operation.hide()">Close</button>
  </div>
</ng-template>